import styled from 'styled-components';

const TableHead = styled.th`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 19px;
  text-transform: uppercase;
  background-color: #f3e7da;
  text-align: start;
`;

export default TableHead;
